import {
  canShowOwnedResource,
  canShowScopedResource,
  type ResourceScope,
  type ResourceStatus,
} from '../scopedResource';

export const canShowContact = ({
  pageOwnerAui,
  contactOwnerAui,
  contactScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  contactOwnerAui: string | null;
  contactScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui: contactOwnerAui,
    resourceScope: contactScope,
    currentScope,
    status,
  });

export const canShowContactPropertyVisible = ({
  pageOwnerAui,
  visibleOwnerAui,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  visibleOwnerAui: string | null;
  status: ResourceStatus;
}): boolean =>
  canShowOwnedResource({
    pageOwnerAui,
    resourceOwnerAui: visibleOwnerAui,
    status,
  });
